import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { IntlProvider, useIntl } from 'react-intl';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  Typography,
  Alert,
  Box,
  Collapse,
  ThemeProvider,
} from '@mui/material';
import { lightTheme } from '../../../themes';
import { DEFAULT_LOCALE, localeMessages } from '../../../state/domain/Locale';

function NoticePopup({ open, message, onClose, errors = null }) {
  const { formatMessage } = useIntl();
  const [checked, setChecked] = useState(false);
  const handleChange = () => {
    setChecked(prev => !prev);
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {formatMessage({
          id: 'STALE_DATA_DETECTED',
          defaultMessage: 'Stale Data Detected',
        })}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2">
          {message ||
            formatMessage({
              id: 'STALE_DATA_MESSAGE',
              defaultMessage:
                'The information on this page is out of date.\nWe will refresh the page to make sure you’re seeing the most current details',
            })}
        </Typography>

        {errors && Array.isArray(errors) && errors.length > 0 && (
          <Box sx={{ mt: 1 }}>
            <Typography
              onClick={() => handleChange()}
              sx={{
                cursor: 'pointer',
                textDecoration: 'underline',
                color: 'primary.main',
              }}>
              {checked
                ? formatMessage({
                    id: 'HIDE_TECHNICAL_DETAILS',
                    defaultMessage: 'Hide Technical Details',
                  })
                : formatMessage({
                    id: 'SHOW_TECHNICAL_DETAILS',
                    defaultMessage: 'Show Technical Details',
                  })}
            </Typography>
            <Collapse in={checked}>
              <Alert icon={false} severity="error">
                {errors.map((error, index) => {
                  return (
                    <Box key={error?.message || index}>
                      <span>{error?.message}</span>
                    </Box>
                  );
                })}
              </Alert>
            </Collapse>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={onClose} variant="contained" color="primary">
          {formatMessage({ id: 'OK', defaultMessage: 'Ok' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export const showNoticePopup = async (message, errors = null) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);

  const handleClose = () => {
    root.unmount();
    container.remove();
    window.location.reload();
  };

  const locale =
    JSON.parse(window.localStorage.getItem('LocaleStore'))?.locale ||
    DEFAULT_LOCALE;
  const messages = await localeMessages[locale].loadMessages();

  root.render(
    <IntlProvider
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
      messages={messages}>
      <ThemeProvider theme={lightTheme}>
        <NoticePopup
          open
          message={message}
          errors={errors}
          onClose={handleClose}
        />
      </ThemeProvider>
    </IntlProvider>,
  );
};

export default NoticePopup;
